import axios from "axios";
import { SERVER_URL } from "../../config";
import { appendTimestamp } from "../../common/shared";
import store from "../../redux/store";

export const getAdvisorDefaultPlanSettings = (advisorId) => {
  console.log("Default Plan Settings API - getDefaultPlanSettings");

  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/settings/plan/default`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveAdvisorDefaultPlanSettings = (advisorId, firmId) => {
  console.log("Default Plan Settings API - saveDefaultPlanSettings");

  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/settings/plan/default`
    );

    let settings = store.getState().settingsReducer;

    let data = {
      firmId: firmId,
      defaultSettings: {
        inflationAndDiscount: {
          isSystemWideInflation: settings.getIn([
            "advisor",
            "defaultInflation",
            "isSystemWide",
          ]),
          systemWideInflation:
            settings.getIn([
              "advisor",
              "defaultInflation",
              "systemWideInflation",
            ]) * 100,
          discountRate:
            settings.getIn(["advisor", "defaultInflation", "discountRate"]) *
            100,
          incomeInflation:
            settings.getIn(["advisor", "defaultInflation", "income"]) * 100,
          contributionsWithdrawalInflation:
            settings.getIn(["advisor", "defaultInflation", "contributions"]) *
            100,
          goalInflation:
            settings.getIn(["advisor", "defaultInflation", "goal"]) * 100,
          expenseInflation:
            settings.getIn(["advisor", "defaultInflation", "expense"]) * 100,
        },
        planSimulation: {
          isFutureValue: settings.getIn([
            "advisor",
            "planSimulation",
            "futureValue",
          ]),
          isLogarithimic: settings.getIn([
            "advisor",
            "planSimulation",
            "logarithmic",
          ]),
          isProrateFirstYear: settings.getIn([
            "advisor",
            "planSimulation",
            "proRateFirstYear",
          ]),
          numberOfSimulation: settings.getIn([
            "advisor",
            "planSimulation",
            "numberOfSimulations",
          ]),
        },
        clientKeyDates: {
          retirementAge: settings.getIn([
            "advisor",
            "clientKeyDates",
            "retirementAge",
          ]),
          lifeExpectancyAge: settings.getIn([
            "advisor",
            "clientKeyDates",
            "lifeExpectancy",
          ]),
        },
        trackingThresholds: {
          goalBasedPlan: {
            min:
              settings.getIn([
                "advisor",
                "trackingThresholds",
                "goalBased",
                "from",
              ]) * 100,
            max:
              settings.getIn([
                "advisor",
                "trackingThresholds",
                "goalBased",
                "to",
              ]) * 100,
          },
          safeSavingsRatePlan: {
            min:
              settings.getIn([
                "advisor",
                "trackingThresholds",
                "ssrPlan",
                "from",
              ]) * 100,
            max:
              settings.getIn([
                "advisor",
                "trackingThresholds",
                "ssrPlan",
                "to",
              ]) * 100,
          },
        },
      },
    };

    axios.post(targetUrl, data).then((response) => {
      resolve(response.data.payload);
    });
  });
};
